export default __webpack_public_path__ + "static/media/degres-red.177fa395.svg";